import { useEffect, useRef } from 'react'
import { useDmCallStore } from '@os/messenger/web/stores/dmCallStore'
import { sounds } from '../services/sounds'

export function useDmCallSounds() {
  const callState = useDmCallStore((s) => s.callState)
  const prevStateRef = useRef(callState)

  useEffect(() => {
    const prev = prevStateRef.current
    const next = callState

    // Outgoing ring: play while in 'outgoing' state
    if (next === 'outgoing') {
      sounds.outgoingRing()
    } else {
      sounds.stopOutgoingRing()
    }

    // Connected tone: play when transitioning to 'connected'
    if (next === 'connected' && prev !== 'connected') {
      sounds.callConnected()
    }

    prevStateRef.current = next

    return () => {
      // Cleanup on unmount: stop outgoing ring if playing
      sounds.stopOutgoingRing()
    }
  }, [callState])
}
